"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewTypeForRuntimeProgress = void 0;
/**
 * "viewType" value used to show runtime progress in builtin/default frontend
 */
exports.ViewTypeForRuntimeProgress = 'runtime_progress';
//# sourceMappingURL=pages-spanggle-builtin.js.map